module.exports = __webpack_public_path__ + "img/sanzu river.52f70953.png";